import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import SearchBar from 'components/SearchBar/SearchBar.jsx';
import VideoCard from 'components/Card/VideoCard.jsx';
import Paginator from "components/Controls/Paginator.jsx";
import iconsStyle from "assets/jss/material-dashboard-react/views/iconsStyle.jsx";
import { refreshToken, APIRoot } from 'variables/authentication.jsx';
import { sortables, sort_modes } from 'variables/sortables.jsx';
import Api from 'services/api';

const VideosAPIRoot = "/videos";
const UsersAPIRoot = "/users";

class Picks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      video_data: [],
      featuredOnly: false,
      clientToken: localStorage.getItem("accessToken"),
      sortString: "?",
      page: 0,
      prev_search: "",
      sortOptions: sortables.map((sortable) => { return sort_modes.NONE }),
    }
    this.Search = this.Search.bind(this);
    this.blindSearch = this.blindSearch.bind(this);
    this.toggleFeature = this.toggleFeature.bind(this);
    this.Feature = this.Feature.bind(this);
    this.updateSort = this.updateSort.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.blindSearch();
  }


  updateSort(sortType, index) {
    var sortOptions = this.state.sortOptions;
    sortOptions[index] = sortType;
    var sortString = '';
    for (let i in this.state.sortOptions) {
      if (this.state.sortOptions[i] == sort_modes.ASC) {
        sortString += ',' + sortables[i].value;
      }
      else if (this.state.sortOptions[i] == sort_modes.DESC) {
        sortString += ',-' + sortables[i].value;
      }
    }
    sortString = sortString == '' ? '?' : '?sort=' + sortString.slice(1) + '&';
    this.setState({ sortString: sortString, sortOptions: sortOptions }, () => {
      this.Search({ 'target': { 'value': this.state.prev_search } });
    });

  }

  updatePage(pageNum) {
    this.setState({ page: this.state.page + pageNum }, () => {
      this.Search({ 'target': { 'value': this.state.prev_search } });
    });
  }

  toggleFeature() {
    this.setState({ featuredOnly: !this.state.featuredOnly }, () => {
      this.Search({ 'target': { 'value': this.state.prev_search } });
    });
  }


  /* TODO: Code can be refactored to merge into Search() */
  async blindSearch(secondChance = true) {
    var url = VideosAPIRoot + this.state.sortString + `count=20&page=${this.state.page}` + (this.state.featuredOnly ? `&is_krikey_pick=true` : ``);
    const responseData = await Api({ endpoint: url });
    const this_ref = this;
    const featureState = this.state.featuredOnly;
    const pageState = this.state.page;

    responseData.forEach(async (element, i) => {
      const user = await Api({ endpoint: UsersAPIRoot + `?id=${element.user_id}`, headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      if (featureState == this_ref.state.featuredOnly && pageState == this_ref.state.page && this_ref.state.prev_search == "") { //if featuredOnly state changed, abort this action
        responseData[i].username = user[0] && user[0].username;
        this_ref.setState({ video_data: responseData })
      }
    })

    this.setState({ video_data: responseData })
  }

  Feature(element, secondChance = true) {

    if (element.is_krikey_pick) {
      element.is_krikey_pick = false;
    }
    else {
      element.is_krikey_pick = true;
    }
    for (var i in this.state.video_data) {
      if (this.state.video_data[i].id == element.id) {
        this.state.video_data[i].is_krikey_pick = element.is_krikey_pick;
      }
    }
    this.setState({ video_data: this.state.video_data })
    const userVideo = Api({ endpoint: `${VideosAPIRoot}/${element.id}`, body: JSON.stringify({ is_krikey_pick: element.is_krikey_pick }) })
    if (userVideo.is_krikey_pick == element.is_krikey_pick) {
      return;
    }
    for (var i in this.state.video_data) {
      if (this.state.video_data[i].id == element.id) {
        this.state.video_data[i].is_krikey_pick = element.is_krikey_pick;
      }
    }
    this.setState({ video_data: this.state.video_data })
  }

  async Search(event, secondChance = true) {
    if (event.target.value != this.state.prev_search)
      this.setState({ prev_search: event.target.value, page: 0 });
    if (event.target.value == "") {
      return this.blindSearch();
    }
    const responseData = await Api({ endpoint: `${UsersAPIRoot}?count=20&page=${this.state.page}&username=${event.target.value}` })

    if (responseData == undefined) return;
    if (responseData.length >= 1) {
      const videoResponseData = await Api({ endpoint: `${VideosAPIRoot}${this.state.sortString}user_id=${responseData[0].id} ${this.state.featuredOnly ? "is_krikey_pick=true" : ''}` });
      videoResponseData.forEach(function (element) {
        element.username = responseData[0].username;
      });
      this.setState({ video_data: videoResponseData })

    }
    else if (this.state.video_data.length > 0) {
      this.setState({ video_data: [] })
    }

  }


  render() {
    const { classes } = this.props;
    return (
      <div>
        <SearchBar onChange={this.Search}
          onToggle={this.toggleFeature}
          featuredOnly={this.state.featuredOnly}
          updateSort={this.updateSort}
          sortOptions={this.state.sortOptions}
        />
        <GridContainer>
          {this.state.video_data.map((element, i) =>
            <GridItem xs={3} sm={3} md={3} key={element.id}>
              <VideoCard video_data={element} feature={this.Feature} />
            </GridItem>
          )}
        </GridContainer>
        <Paginator
          updatePage={this.updatePage}
          page={this.state.page}
          rightDisabled={this.state.video_data.length < 20}
        />
      </div>
    );
  }
}


Picks.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(iconsStyle)(Picks);
